import { ToastUtils } from '@forgeglobal/design-framework';
import { useOktaAuth } from '@okta/okta-react';
import {
  ReportPreferences,
  UpdateReportPreferencesRequest,
} from '@tcs/client-portal-api/types/ReportPreferences';
import { getConfig } from '@tcs/client-portal/config/configService';
import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';

export const useReportPreferencesMutation = (representativeCode: string) => {
  const queryClient = useQueryClient();
  const { oktaAuth } = useOktaAuth();

  return useMutation(
    async (preferences: UpdateReportPreferencesRequest) => {
      const config = getConfig();
      const tokens = await oktaAuth.tokenManager.getTokens();
      const token = tokens.accessToken?.accessToken;
      return axios.put<ReportPreferences>(
        `${config.API_BASE_URL}/rss/reportpreferences/${representativeCode}`,
        preferences,
        {
          headers: {
            'Content-Type': `application/json`,
            'x-tcs-authorization': token,
          },
        }
      );
    },
    {
      onError: () => {
        ToastUtils.error(`Failed to save report preferences.`, true);
      },
      onSuccess: () => {
        queryClient.invalidateQueries(
          `/rss/reportpreferences/${representativeCode}`
        );
        ToastUtils.success(`Report preferences have been saved.`, true);
      },
    }
  );
};

export default useReportPreferencesMutation;
